import React, { Fragment, memo } from 'react';
import { useForm } from 'react-hook-form';
import { classValidatorResolver } from '@hookform/resolvers/class-validator';
import { customerApi } from '@app/store';
import { CustomerDTO } from '@app/common';
import { Button, Form, Panel } from '@app/components';
import { CustomerForm } from './CustomerForm';
import { CustomerFormValues } from './customer-form.helpers';
import { useToast, useTriptych } from '@app/hooks';
import { CustomerCard } from './CustomerCard';

export const CustomerCreate = memo(() => {
  const toast = useToast();

  const triptych = useTriptych()

  const [create, { isLoading, error: apiErrors }] = customerApi.useCreateOneCustomersMutation();

  const formMethods = useForm<CustomerFormValues>({
    resolver: classValidatorResolver(CustomerDTO),
    defaultValues: {
      firstname: '',
      lastname: '',
      email: '',
      phone: '',
      birthday: '',
      addresses: [],
      shops: [],
      optInEmail: false,
      optInLoyalty: false,
      optInSMS: false,
    },
  });

  const onCreate = async (formValues: CustomerFormValues) => {
    try {
      const customer = await create(formValues).unwrap();

      triptych.close({ mode: 'UPDATE', data: customer });

      toast.success('Le client a bien été ajouté.')
    } catch {
      toast.error('Une erreur est survenue lors de la création du client.')
    }
  }

  return (
    <Fragment>
      <CustomerCard
        formMethods={formMethods}
        toggle={() => triptych.toggle()} />

      <Panel.Content>

        <Form formMethods={formMethods} apiErrors={apiErrors}>

          <Panel.FormContainer>

            <CustomerForm />

          </Panel.FormContainer>

          <Panel.Actions>
            <Button
              title="Retour"
              grow
              large
              bordered
              onPress={() => triptych.close()} />

            <Button
              loading={isLoading}
              title="Valider"
              onPress={formMethods.handleSubmit(onCreate)}
              grow
              large />
          </Panel.Actions>

        </Form>

      </Panel.Content>
    </Fragment>
  );
}); 